import { AppDefinition } from '../../types/apps';

export const HtmlCanvasAppDefinition: AppDefinition = {
  appId: 'html-canvas',
  name: 'HTML Canvas',
  version: '0.1.0',
  description:
    'A live HTML/CSS/JS editor with real-time collaborative editing and a sandboxed live preview. Write HTML, style it with CSS, add interactivity with JavaScript — the preview updates as you type.',
  icon: {
    type: 'phosphor',
    phosphorIcon: 'AppWindow',
    phosphorWeight: 'duotone',
    color: '#6366f1',
    metadata: { source: 'app', appId: 'html-canvas', isAppIcon: true },
  },
  entityIcons: {
    HtmlCanvas: {
      type: 'phosphor',
      phosphorIcon: 'AppWindow',
      phosphorWeight: 'duotone',
      color: '#6366f1',
    },
  },
  entityTypes: ['HtmlCanvas'],
  searchableSkeletonFields: {
    // The Y.Doc is the source of truth; only the thin mirror is indexed — never the raw HTML.
    HtmlCanvas: ['description', 'tags', 'title'],
  },
  component: 'HtmlCanvasApp',
  requiresProps: false,
  requiresEntity: true,
  agenticToolIds: [
    'htmlcanvas_create',
    'html_canvas_write',
    'entity_read_content',
  ],
  actions: {},
};
